<ion-item class="title-field-item">

  <ion-label>

    <p class="title">{{ field.label }}</p>

    @if (field.info) {
      <p class="info">{{ field.info }}</p>
    }

  </ion-label>

</ion-item>
